import script from "./TasksForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksForm.vue?vue&type=script&setup=true&lang=js"

import "./TasksForm.vue?vue&type=style&index=0&id=233a890e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233a890e"]])

export default __exports__